// import i18n from "../../i18n";
import LanguageService from "@/service/LanguageService";

let model = {};

// dữ liệu form
model.dataCardItems = {
  id: undefined, // optional - Mã tự sinh
  card_id: undefined, // optional, ref: card - Mã card
  type: undefined, // required, enum(chart-bar-vert-single, chart-bar-vert-multi, chart-bar-hori-single, chart-bar-hori-multi, chart-line-single, chart-line-multi, chart-line-area-single, chart-line-area-multi, chart-pie, chart-stack-bar-vert, chart-stack-bar-hori, chart-radar, table, group-text, err-network-2segments, err-network-3segments, stats-network-multi-serv, time-line, info-single, table-screen, score, impression, text-card) - Loại card item
  title: undefined, // required - Tiêu đề
  // optional - Các thuộc tính chung của card item
  general: {
    // optional - Cấu hình header của card item
    header: {
      is_hidden: undefined, // optional
      color: undefined, // optional - Màu
      backgroundColor: undefined, // optional - Màu nền
    },
  },
  x: undefined, // required - Tọa độ x
  y: undefined, // required - Tọa độ y
  width: undefined, // required - Chiều ngang
  height: undefined, // required - Chiều dọc
  table_config_id: undefined, // required, ref: table_config - Mã của table_config
  // optional - các thuộc tính của table nếu type là table
  table: {
    hasNo: undefined, // required - Có cột số thứ tự hay không
    isPaging: undefined, // required - Có phân trang hay không
    format: [
      // optional - Danh sách thông tin định dạng các cột
      {
        code: undefined, // optional - Mã trường
        field_name: undefined, // required - Tên trường
        title_name: undefined, // optional - Tên cột
        // optional - Cấu hình icon
        icon: {
          visible: undefined, // optional - Cho phép hiển thị không
          file_id: undefined, // optional, ref: icon - Id file icon
        },
        visible: undefined, // optional - Có hiển thị không
        defaultHide: undefined, // optional - Cho biết có mặc định sẽ ẩn hay không (người dùng có thể tick để hiển thị trên giao diện)
        type: undefined, // optional, enum(none, rate, progress) - Kiểu cột
        default_value: undefined, // optional - Giá trị mặc định
        width: undefined, // optional - Kích thước cột
        font_size: undefined, // optional - Kích thước font chữ
        color: undefined, // optional - Màu font chữ
        bold: undefined, // optional - Bôi đậm
        italic: undefined, // optional - Chữ nghiêng
        underline: undefined, // optional - Gạch chân
        align: undefined, // optional, enum(left, center, right, justify) - Căn chỉnh vị trí
        tooltip: undefined, // optional - Tooltip cho header của cột
        // optional
        cell_tooltip: {
          source_column_code: undefined, // optional - Mã cột chứa dữ liệu để sinh tooltip. Dữ liệu này hỗ trợ format markdown
        },
        // optional - Thông tin cấu hình popup khi click vào cell
        popup: {
          popup_id: undefined, // optional, ref: dashboard_popup - Mã dashboard popup
        },
        formatString: undefined, // optional - Định dạng chuỗi
        // optional - Thông tin để sinh ra Link cho cell
        cellLink: {
          valueColumn: undefined, // required - Tên cột chứa dữ liệu so sánh. Là tên cột trong api trả về; đứng sau as trong câu sql
          links: [
            // required - Danh sách các link của cell
            {
              values: [], // required, minLength: 1, array items: required - Danh sách các giá trị của valueColumn để hiển thị link này
              formatString: undefined, // required - Chuỗi định dạng để sinh ra nội dung cell
            },
          ],
          // optional - Cấu hình sinh ra link khi không giá trị nào của valueColumn nằm trong links.values
          defaultLink: {
            formatString: undefined, // required - Chuỗi dùng để sinh ra cell
          },
        },
        // optional - Cấu hình lọc
        filter: {
          is_allowed: undefined, // optional - Cho phép lọc không
          input_type: undefined, // optional, enum(input, select, datepicker, tag_input, number) - Kiểu input
          is_suggestion: undefined, // optional - Đối với loại tag input. Có cho phép hiển thị gợi ý không?
          suggest_values: [], // optional - Danh sách lựa chọn (đối với kiểu select hoặc tag_input)
        },
        // optional - Cấu hình sắp xếp
        sort: {
          is_allowed: undefined, // optional - Cho phép sắp xếp không
          type: undefined, // optional, enum(String, Date, Number) - Loại dữ liệu sort
          default: undefined, // optional - Kiểu sắp xếp mặc định
        },
      },
    ],
  },
  // optional - các thuộc tính của chart nếu type là chart-*
  chart: {
    // optional - Tiêu đề
    title: {
      show: undefined, // optional - Hiển thị hay không
      text: undefined, // optional - Nội dung tiêu đề
      // optional - Định dạng text
      textStyle: {
        fontSize: undefined, // optional - Kích thước font chữ
        color: undefined, // optional - Màu chữ
      },
    },
    // optional - Tiêu đề
    legend: {
      show: undefined, // optional - Hiển thị hay không
      orient: undefined, // optional, enum(horizontal, vertical) - Xếp theo chiều ngang hay thẳng đứng
      // optional - Tiêu đề
      align: {
        horizontal: undefined, // optional, enum(left, center, right) - Vị trí theo chiều ngang
        vertical: undefined, // optional, enum(top, middle, bottom) - Vị trí theo chiều dọc
      },
      left: undefined, // optional - Căn trái
      top: undefined, // optional - Căn đỉnh
      right: undefined, // optional - Căn phải
      bottom: undefined, // optional - Căn đáy
    },
    // optional - Tiêu đề
    tooltip: {
      show: undefined, // optional - Hiển thị hay không
      trigger: undefined, // optional, enum(item, axis, none) - Dạng trigger để hiển thị
      backgroundColor: undefined, // optional - Màu nền
      borderRadius: undefined, // optional - Bo góc
      // optional - Định dạng text
      textStyle: {
        fontSize: undefined, // optional - Kích thước font chữ
        color: undefined, // optional - Màu chữ
      },
    },
    // optional - Các cấu hình cho trục hoành
    x_axis: {
      min: undefined, // optional - Chiều ngang tối thiểu của biểu đồ
      max: undefined, // optional - Chiều ngang tối đa của biểu đồ
      // optional - Cấu hình cho label trục hoành
      axisLabel: {
        rotate: undefined, // optional, min: -90, max: 90 - Độ nghiêng
      },
      // optional - Cấu hình split line
      splitLine: {
        // optional - Cấu hình line style
        lineStyle: {
          color: undefined, // optional - Màu
          type: undefined, // optional, enum(solid, dashed, dotted) - Loại
          width: undefined, // optional - Chiều dài
        },
      },
    },
    // optional - Các cấu hình cho trục tung
    y_axis: {
      min: undefined, // optional - Chiều cao tối thiểu của biểu đồ
      max: undefined, // optional - Chiều cao tối đa của biểu đồ
      // optional - Cấu hình cho label trục tung
      axisLabel: {
        rotate: undefined, // optional, min: -90, max: 90 - Độ nghiêng
      },
      // optional - Cấu hình split line
      splitLine: {
        // optional - Cấu hình line style
        lineStyle: {
          color: undefined, // optional - Màu
          type: undefined, // optional, enum(solid, dashed, dotted) - Loại
          width: undefined, // optional - Chiều dài
        },
      },
    },
    data_serials: [],
    multi_color_for_single_bar_chart: undefined, // optional - Flag cấu hình màu cho biểu đồ chart-bar-vert-single và chart-bar-hori-single
    chart_link: undefined, // optional - Đường dẫn khi click vào biểu đồ chart
    // optional - Thông tin cấu hình popup khi click vào biểu đồ chart
    popup: {
      popup_id: undefined, // optional, ref: dashboard_popup - Mã dashboard popup
    },
    color: [], // optional - Danh sách màu cho chart (không dùng nữa, bị sẽ xóa, dùng data_serials.bg_color)
    // optional - Cấu hình style cho item
    itemStyle: {
      borderRadius: [], // optional - Thông số bo góc cho item
    },
    // optional - Cấu hình style cho area (không dùng nữa, bị sẽ xóa, dùng data_serials.bg_color)
    areaStyle: {
      colors: [], // optional - Thông số màu cho area
    },
    borderRadiusType: undefined, // optional, enum(none, small, large) - Bo góc cho cột
    barMaxWidth: undefined, // optional, gt: 0 - Độ rộng tối đa của cột (px) cho các chart dạng bar
    smooth: undefined, // optional - Cấu hình line smooth cho các chart có dạng line
    // optional - Cấu hình thông tin cảnh báo cho chart
    alert: {
      sql: undefined, // optional - Câu truy vấn lấy về thông tin cảnh báo. Lưu ý phải có @table
      sql_table_formats: [], // optional - Câu truy vấn con trong biến @table dạng select..from @table_name where...
      table_config_id: undefined, // optional, ref: table_config - Mã table_config dùng để sinh ra tên table cho @table trong sql
    },
  },
  // optional - Các thuộc tính của network nếu type là -network-
  network: {
    service_ids: [], // optional - Danh sách mã service
  },
  // optional - Các cấu hình card item loại info-single
  info_single: {
    icon_id: undefined, // optional, ref: icon - Id của icon
    // optional - Các cấu hình label cho card item loại info-single
    label: {
      fontSize: undefined, // optional - Kích thước font chữ
      color: undefined, // optional - Màu
      backgroundColor: undefined, // optional - Màu nền
    },
    // optional - Các cấu hình value cho card item loại info-single
    value: {
      fontSize: undefined, // optional - Kích thước font chữ
      color: undefined, // optional - Màu
      backgroundColor: undefined, // optional - Màu nền
    },
  },
  // optional - Các cấu hình card item loại impression
  impression: {
    // required - Cấu hình icon ảnh
    icon: {
      icon_id: undefined, // required, ref: card_item_icon - Id của icon
      position: undefined, // required, enum(top_left, top_center, top_right, middle_left, middle_right, bottom_left, bottom_center, bottom_right) - Vị trí hiển thị của icon
      width: undefined, // required, gt: 0 - Độ rộng của icon
      height: undefined, // required, gt: 0 - Độ cao của icon
    },
    // optional - Các cấu hình của Tiêu đề
    title: {
      text: undefined, // optional - Nội dung tiêu đề
      fontSize: undefined, // optional - Kích thước font chữ
      color: undefined, // optional - Màu chữ
      bold: undefined, // optional - Cho biết có bold hay không
    },
    // optional - Các cấu hình của Tiêu đề phụ
    sub_title: {
      text: undefined, // optional - Nội dung tiêu đề phụ
      fontSize: undefined, // optional - Kích thước font chữ
      color: undefined, // optional - Màu chữ
      bold: undefined, // optional - Cho biết có bold hay không
    },
    // optional - Các cấu hình của text value
    value: {
      fontSize: undefined, // optional - Kích thước font chữ
      color: undefined, // optional - Màu chữ
      bold: undefined, // optional - Cho biết có bold hay không
    },
    // optional - Các cấu hình của Đơn vị
    unit: {
      text: undefined, // optional - Nội dung đơn vị
      fontSize: undefined, // optional - Kích thước font chữ
      color: undefined, // optional - Màu chữ
      bold: undefined, // optional - Cho biết có bold hay không
    },
    // optional - Cấu hình xử lý khi click vào card item
    action: {
      link: undefined, // optional - Đường dẫn khi click vào card item
      popup_id: undefined, // optional, ref: dashboard_popup - Mã dashboard popup sẽ hiển thị khi click vào card item
    },
  },
  // optional - Các cấu hình card item loại score
  score: {
    show_star: undefined, // optional - Cho biết có hiển thị 5 sao hay không
    // optional - Các cấu hình của text value
    value: {
      fontSize: undefined, // optional - Kích thước font chữ
      color: undefined, // optional - Màu chữ
    },
    // optional - Các cấu hình của Tiêu đề phụ
    sub_title: {
      text: undefined, // optional - Nội dung tiêu đề phụ
      fontSize: undefined, // optional - Kích thước font chữ
      color: undefined, // optional - Màu chữ
    },
    // optional - Cấu hình xử lý khi click vào card item
    action: {
      link: undefined, // optional - Đường dẫn khi click vào card item
      popup_id: undefined, // optional, ref: dashboard_popup - Mã dashboard popup sẽ hiển thị khi click vào card item
    },
  },
  // optional - Các cấu hình card item loại text_card
  text_card: {
    // required - Cấu hình icon ảnh
    icon: {
      width: undefined, // required, gt: 0 - Độ rộng của icon
      height: undefined, // required, gt: 0 - Độ cao của icon
    },
    // optional - Các cấu hình của Tiêu đề
    title: {
      fontSize: undefined, // optional - Kích thước font chữ
      color: undefined, // optional - Màu chữ
      bold: undefined, // optional - Cho biết có bold hay không
    },
    content: {
      fontSize: undefined,
    },
    // optional - Cấu hình xử lý khi click vào card item
    action: {
      link: undefined, // optional - Đường dẫn khi click vào card item
      popup_id: undefined, // optional, ref: dashboard_popup - Mã dashboard popup sẽ hiển thị khi click vào card item
      title_link: undefined, // optional - Đường dẫn khi click vào các tiêu đề của text card
      title_popup_id: undefined, // optional, ref: dashboard_popup - Mã dashboard popup sẽ hiển thị khi click vào các tiêu đề của text card
    },
  },
  sql: undefined, // optional - câu truy vấn để lấy dữ liệu
  sql_table_formats: [], // optional - câu truy vấn con trong biến @table dạng select..from @table_name where...
  // optional - Các cấu hình khác
  settings: {
    add_start_days: undefined, // optional - số ngày được dịch chuyển so với ngày bắt đầu
    add_end_days: undefined, // optional - số ngày được dịch chuyển so với ngày kết thúc
  },
};

model.formatAlign = [
  {
    value: "left",
    label: LanguageService?.lang?.align_left ?? "align_left",
  },
  {
    value: "right",
    label: LanguageService?.lang?.align_right ?? "align_right",
  },
  {
    value: "center",
    label: LanguageService?.lang?.align_center ?? "align_center",
  },
  {
    value: "justify",
    label: LanguageService?.lang?.align_justify ?? "align_justify",
  },
];

model.typeColumns = [
  {
    value: "none",
    label: LanguageService?.lang?.none_type_columns ?? "none_type_columns",
  },
  {
    value: "rate",
    label: LanguageService?.lang?.rate_type_columns ?? "rate_type_columns",
  },
  {
    value: "progress",
    label:
      LanguageService?.lang?.progress_type_columns ?? "progress_type_columns",
  },
];

model.visibleColumns = [
  {
    value: true,
    label: LanguageService?.lang?.unvisible_columns ?? "unvisible_columns",
  },
  {
    value: false,
    label: LanguageService?.lang?.visible_columns ?? "visible_columns",
  },
];

model.impressionIconposition = [
  {
    value: "top_left",
    label: LanguageService?.lang?.t_top_left ?? "t_top_left",
  },
  {
    value: "top_center",
    label: LanguageService?.lang?.t_top_center ?? "t_top_center",
  },
  {
    value: "top_right",
    label: LanguageService?.lang?.t_top_right ?? "t_top_right",
  },
  {
    value: "middle_left",
    label: LanguageService?.lang?.t_middle_left ?? "t_middle_left",
  },
  {
    value: "middle_right",
    label: LanguageService?.lang?.t_middle_right ?? "t_middle_right",
  },
  {
    value: "bottom_left",
    label: LanguageService?.lang?.t_bottom_left ?? "t_bottom_left",
  },
  {
    value: "bottom_right",
    label: LanguageService?.lang?.t_bottom_right ?? "t_bottom_right",
  },
  {
    value: "bottom_center",
    label: LanguageService?.lang?.t_bottom_center ?? "t_bottom_center",
  },
];

model.typeFilter = [
  {
    value: "input",
    label: "Input",
  },
  {
    value: "select",
    label: "Select",
  },
  {
    value: "datepicker",
    label: "Datepicker",
  },
  {
    value: "tag_input",
    label: "Tag input",
  },
  {
    value: "number",
    label: "Number",
  },
];

model.typeSort = [
  {
    value: "String",
    label: "String",
  },
  {
    value: "Date",
    label: "Date",
  },
  {
    value: "Number",
    label: "Number",
  },
];
model.formatLegend = [
  {
    value: "horizontal",
    label: LanguageService?.lang?.t_horizontal ?? "t_horizontal",
  },
  {
    value: "vertical",
    label: LanguageService?.lang?.t_vertical ?? "t_vertical",
  },
];
model.horizontalLegend = [
  // mặc định là center
  {
    value: "left",
    label: LanguageService?.lang?.t_left ?? "t_left",
  },
  {
    value: "center",
    label: LanguageService?.lang?.t_center ?? "t_center",
  },
  {
    value: "right",
    label: LanguageService?.lang?.t_right ?? "t_right",
  },
];
model.verticalLegend = [
  // mặc định là bottom
  {
    value: "top",
    label: LanguageService?.lang?.t_top ?? "t_top",
  },
  {
    value: "middle",
    label: LanguageService?.lang?.t_middle ?? "t_middle",
  },
  {
    value: "bottom",
    label: LanguageService?.lang?.t_bottom ?? "t_bottom",
  },
];

model.typeBorder = [
  {
    value: "none",
    label: LanguageService?.lang?.t_none ?? "t_none",
  },
  {
    value: "small",
    label: LanguageService?.lang?.t_small ?? "t_small",
  },
  {
    value: "large",
    label: LanguageService?.lang?.t_large ?? "t_large",
  },
];
model.listDashboards = [
  {
    value: "main",
    label: "Dashboard probe",
  },
  {
    value: "service",
    label: LanguageService?.lang?.["t-service"] ?? "t-service",
  },
  // {
  //   value: "customer",
  //   label: "Khách hàng",
  // },
  {
    value: "timespan",
    label:
      LanguageService?.lang?.t_dashboard_timespan ?? "t_dashboard_timespan",
  },
  {
    value: "dynamic",
    label: "Dynamic",
  },
  {
    value: "menu",
    label: LanguageService?.lang?.t_list_menu ?? "t_list_menu",
  },
  // {
  //   value: "session",
  //   label: "Session",
  // },
];

model.colorDefault = [
  "#407BFF",
  "#7489FF",
  "#A4A6FE",
  "#A1E3CB",
  "#50E7B0",
  "#A1F6FC",
  "#F1F37C",
  "#FFDB5E",
  "#F7CF95",
  "#FFB69E",
  "#FFA869",
  "#FA7DFD",
  "#FF3131",
  "#F15D76",
];
model.colorDefaultGradientBarChart = [
  ["#407BFF", "#A6C1FF"],
  ["#95A4FC", "#D8D8FF"],
  ["#C6C7F8", "#E5E6FF"],
  ["#A1E3CB", "#D9FBEF"],
  ["#BAEDBD", "#E4FFE6"],
  ["#C9F5F8", "#E8FEFF"],
  ["#EFF0C1", "#FEFFE4"],
  ["#FFE999", "#FFF3C8"],
  ["#ECDBC1", "#FFF5E7"],
  ["#FFD7CB", "#FFE9E2"],
  ["#FFC499", "#FFE0CA"],
  ["#F4B2F5", "#FED9FF"],
  ["#FF3131", "#FFA6A6"],
  ["#F15D76", "#FBB9C3"],
];
model.colorDefaultGradientAreaChart = [
  ["#407BFF", "#A6C1FF", "#FFFFFF"],
  ["#7489FF", "#95A4FC", "#FFFFFF"],
  ["#A4A6FE", "#C6C7F8", "#FFFFFF"],
  ["#A1E3CB", "#BAEDBD", "#FFFFFF"],
  ["#50E7B0", "#A1E3CB", "#FFFFFF"],
  ["#A1F6FC", "#C9F5F8", "#FFFFFF"],
  ["#F1F37C", "#EFF0C1", "#FFFFFF"],
  ["#FFDB5E", "#FFE999", "#FFFFFF"],
  ["#F7CF95", "#ECDBC1", "#FFFFFF"],
  ["#FFB69E", "#FFD7CB", "#FFFFFF"],
  ["#FFA869", "#FFC499", "#FFFFFF"],
  ["#FA7DFD", "#F4B2F5", "#FFFFFF"],
  ["#FF3131", "#FFA6A6", "#FFFFFF"],
  ["#F15D76", "#FBB9C3", "#FFFFFF"],
];
model.formatColumnsTable = {
  code: undefined, // optional - Mã trường
  field_name: undefined, // required - Tên trường
  title_name: undefined, // optional - Tên cột
  // optional - Cấu hình icon
  icon: {
    visible: undefined, // optional - Cho phép hiển thị không
    file_id: undefined, // optional, ref: icon - Id file icon
  },
  visible: undefined, // optional - Có hiển thị không
  defaultHide: undefined, // optional - Cho biết có mặc định sẽ ẩn hay không (người dùng có thể tick để hiển thị trên giao diện)
  type: undefined, // optional, enum(none, rate, progress) - Kiểu cột
  default_value: undefined, // optional - Giá trị mặc định
  width: undefined, // optional - Kích thước cột
  font_size: undefined, // optional - Kích thước font chữ
  color: undefined, // optional - Màu font chữ
  bold: undefined, // optional - Bôi đậm
  italic: undefined, // optional - Chữ nghiêng
  underline: undefined, // optional - Gạch chân
  align: undefined, // optional, enum(left, center, right, justify) - Căn chỉnh vị trí
  tooltip: undefined, // optional - Tooltip cho header của cột
  // optional
  cell_tooltip: {
    source_column_code: undefined, // optional - Mã cột chứa dữ liệu để sinh tooltip. Dữ liệu này hỗ trợ format markdown
  },
  // optional - Thông tin cấu hình popup khi click vào cell
  popup: {
    popup_id: undefined, // optional, ref: dashboard_popup - Mã dashboard popup
  },
  formatString: undefined, // optional - Định dạng chuỗi
  // optional - Thông tin để sinh ra Link cho cell
  cellLink: {
    valueColumn: undefined, // required - Tên cột chứa dữ liệu so sánh. Là tên cột trong api trả về; đứng sau as trong câu sql
    links: [
      // required - Danh sách các link của cell
      {
        values: [], // required, minLength: 1, array items: required - Danh sách các giá trị của valueColumn để hiển thị link này
        formatString: undefined, // required - Chuỗi định dạng để sinh ra nội dung cell
      },
    ],
    // optional - Cấu hình sinh ra link khi không giá trị nào của valueColumn nằm trong links.values
    defaultLink: {
      formatString: undefined, // required - Chuỗi dùng để sinh ra cell
    },
  },
  // optional - Cấu hình lọc
  filter: {
    is_allowed: undefined, // optional - Cho phép lọc không
    input_type: undefined, // optional, enum(input, select, datepicker, tag_input, number) - Kiểu input
    is_suggestion: undefined, // optional - Đối với loại tag input. Có cho phép hiển thị gợi ý không?
    suggest_values: [], // optional - Danh sách lựa chọn (đối với kiểu select hoặc tag_input)
  },
  // optional - Cấu hình sắp xếp
  sort: {
    is_allowed: undefined, // optional - Cho phép sắp xếp không
    type: undefined, // optional, enum(String, Date, Number) - Loại dữ liệu sort
    default: undefined, // optional - Kiểu sắp xếp mặc định
  },
};
export default model;
